import { SectionImage } from 'services/api/vehicle-sections/types';
import { useExteriorSectionData } from './useExteriorSection';

type Options = {
  raw?: boolean;
};

export const useTireImages = ({ raw = false }: Options = {}) => {
  const { images } = useExteriorSectionData('tires', raw);

  const typedImages = images.reduce((acc, curr) => {
    if (!curr.type || curr.type.includes('_plate')) return acc;
    return { ...acc, [curr.type]: curr };
  }, {} as Record<string, SectionImage>);

  const orderedImages = [
    typedImages['tires.driver_front_tire'],
    typedImages['tires.driver_front_wheel'],
    typedImages['tires.driver_rear_tire'],
    typedImages['tires.driver_rear_wheel'],
    typedImages['tires.passenger_front_tire'],
    typedImages['tires.passenger_front_wheel'],
    typedImages['tires.passenger_rear_tire'],
    typedImages['tires.passenger_rear_wheel'],
    ...images.filter(img => !img.type)
  ];

  if (raw) {
    return orderedImages
  }

  return orderedImages.filter(Boolean);
};
